import { Box } from "@mui/material";
import { Suspense, lazy } from "react";
import { useTranslation } from "react-i18next";
import LoadingProgress from "src/components/app/LoadingProgress";
import PageMeta from "src/components/app/PageMeta";
const KbViewer = lazy(() => import('src/components/knowledgeBase/KbViewer'));

const KnowledgeBaseViewPage = () => {
    const { t } = useTranslation();

    return (
        <>
            <PageMeta title={t('Knowledge base')} />
            <Box sx={{ p: 2, height: 'calc(100vh - 66px)' }}>
                <Box sx={{ bgcolor: 'background.paper', borderRadius: 1 }}>
                    <Suspense fallback={<LoadingProgress open />}>
                        <KbViewer open />
                    </Suspense>
                </Box>
            </Box>
        </>
    );
};

export default KnowledgeBaseViewPage;